var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgEditGray = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0715 4.59994L16.7715 4.99994L19.5715 7.79994L19.9715 7.39994C20.7715 6.59994 20.7715 5.29994 19.9715 4.49994C19.1715 3.79994 17.8715 3.79994 17.0715 4.59994Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6783 6.06164L5.99512 15.7544L7.41012 17.168L17.0933 7.47525L15.6783 6.06164Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1363 7.42395L7.45312 17.1167L8.86812 18.5303L18.5513 8.83755L17.1363 7.42395Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5709 7.8L16.7709 5L15.6709 6L17.0709 7.5L18.5709 8.9L19.5709 7.8Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47148 17.0997L5.97148 15.6997L5.27148 17.7997L6.77148 19.2997L8.87148 18.5997L7.47148 17.0997Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77129 19.2998L5.27129 17.7998L4.57129 19.9998L6.77129 19.2998Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4.57129 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditGray, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EditGray.8db6939b.svg";
export { ForwardRef as ReactComponent };